import { CreatorIntegrationsApiClient } from '@fourthwall/services/dist/CreatorIntegrationsApiClient'
import { useMutation } from '@tanstack/react-query'

export const useDeleteCreatorIntegrationMutation = () => {
  const deleteCreatorIntegrationMutation = useMutation({
    mutationFn: async (app: string) => {
      const { data } = await CreatorIntegrationsApiClient.deleteCreatorIntegration({ app })

      return data
    },
  })

  return { deleteCreatorIntegrationMutation }
}
